var _jsxFileName = "/builds/zillow/hackweek/military-rent-affordability-calculator/src/components/MilitaryRentAffordabilityCalculator/mrac-bah-statement/index.jsx",
    _this = this;

import React from 'react';
import { Paragraph } from '@zillow/constellation';
import PropTypes from 'prop-types';

var MilitaryBahStatement = function MilitaryBahStatement(_ref) {
  var _buildUnfulfilledPara;

  var militaryPaygrade = _ref.militaryPaygrade,
      zipCode = _ref.zipCode,
      dependants = _ref.dependants,
      monthlyBah = _ref.monthlyBah;

  var buildUnfulfilledParamsStatement = function buildUnfulfilledParamsStatement() {
    var missingValues = [];

    if (militaryPaygrade == null) {
      missingValues.push('Paygrade');
    }

    if (zipCode == null) {
      missingValues.push('Zip Code');
    }

    if (dependants == null) {
      missingValues.push('Dependants');
    }

    var missingValuesStatement = null;

    if (missingValues.length > 0) {
      missingValuesStatement = missingValues.join(missingValues.length > 2 ? ', ' : ' and ');
    } else {
      return null;
    }

    var lastCommaIndex = missingValuesStatement.lastIndexOf(', ');

    if (lastCommaIndex > 0) {
      missingValuesStatement = missingValuesStatement.substring(0, lastCommaIndex + 1) + " and" + missingValuesStatement.substring(lastCommaIndex + 1);
    }

    missingValuesStatement = "Please enter your " + missingValuesStatement + " to find your BAH";
    return missingValuesStatement;
  };

  var buildBahStatement = function buildBahStatement() {
    if (monthlyBah == null) {
      return 'Unable to determine your monthly Basic Allowance for Housing';
    }

    return "Your monthly Basic Allowance for Housing is $" + monthlyBah + ".00";
  };

  return /*#__PURE__*/React.createElement(Paragraph, {
    marginY: "md",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 46,
      columnNumber: 9
    }
  }, (_buildUnfulfilledPara = buildUnfulfilledParamsStatement()) !== null && _buildUnfulfilledPara !== void 0 ? _buildUnfulfilledPara : buildBahStatement());
};

MilitaryBahStatement.propTypes = process.env.NODE_ENV !== "production" ? {
  militaryPaygrade: PropTypes.string.isRequired,
  zipCode: PropTypes.number.isRequired,
  dependants: PropTypes.bool.isRequired,
  monthlyBah: PropTypes.number.isRequired
} : {};
export default MilitaryBahStatement;